<template>
  <div class="basic-block block-faq">
    <h3 class="block-faq__title">よくある質問</h3>
    <dl class="block-faq__list">
      <template v-for="(v, i) in faq">
        <dt :key="`dt${i}`">{{ v.q }}</dt>
        <dd :key="`dd${i}`">{{ v.a }}</dd>
      </template>
    </dl>
    <lp-base-button label="もっと占ってみる" design="fill" :color-scheme="colorScheme" class="block-faq__btn" @clicked="clicked" />
  </div>
</template>

<script>
import LpBaseButton from '@/utvStore/components/recommend/lp/partials/LpBaseButton'

export default {
  name: 'BlockFaq',
  components: {
    LpBaseButton,
  },
  props: {
    colorScheme: {
      type: Object,
      default(){
        return {}
      }
    },
    subscUrl: String,
  },
  data() {
    return {
      faq: [
        {
          q: 'Q.登録は必要ですか？',
          a: 'A.占いTVのご利用には会員登録が必要です。登録は、メールアドレスとパスワード、LINEアカウント、Twitterアカウントのいずれかで行えます。',
        },
        {
          q: 'Q.解約はすぐにできますか？',
          a: 'A.いつでも簡単に解約できます。解約にかかる手数料は一切ありません。',
        },
        {
          q: 'Q.利用できる端末やブラウザは？',
          a: 'A.占いTVを快適にご利用いただくために、以下の環境でのご利用を推奨しています。 ※推奨環境を満たしていない場合、正常に動作しない可能性があります。 ※推奨環境下でも、OSとブラウザの組み合わせ、ブラウザの設定状況によっては正常に動作しない場合があります。',
        },
        {
          q: '【iPhone/iPad】',
          a: 'OS：iOS11.0以降 ブラウザ：Safari最新版',
        },
        {
          q: '【Android/Tablet】',
          a: 'OS：Android 6.0以降 ブラウザ：Chrome最新版',
        },
        {
          q: '【パソコン】',
          a: 'ブラウザ：Chrome最新版、Safari最新版（Mac）、Edge最新版（Windows）',
        },
        {
          q: 'Q.1ヶ月定額の支払い方法は何がありますか？',
          a: 'クレジットカード払い、Amazon Payがご利用いただけます。ご利用可能なクレジットカードの種類はVISA、MASTER、JCB、American Expressです。',
        },
      ],
    }
  },
  computed: {
    styles(){
      return {
        '--key-color': this.colorScheme.keyColor,
        '--second': this.colorScheme.second,
        '--grad-start': this.colorScheme.gradStart,
        '--grad-end': this.colorScheme.gradEnd,
      }
    }
  },
  methods: {
    clicked() {
      location.href = this.$handoverParams(this.subscUrl)
    },
  },
}
</script>

<style scoped lang="scss">
@import "../../../../../../sass/commons/commonVariables.scss";

$l_col_keycolor: var(--key-color);
$l_col_second: var(--second);
$l_col_grad_start: var(--grad-start);
$l_col_grad_end: var(--grad-end);
.block-faq {
  padding: 48px 20px 40px;
  background: #F7F7F7;
  &__title {
    font-weight: bold;
    font-size: 24px;
    line-height: 28px;
    text-align: center;
    color: $l_col_keycolor;
    margin: 0 0 28px;
  }
  &__list {
    margin: 0 0 28px;
    dt {
      font-weight: bold;
      font-size: 18px;
      line-height: 21px;
      text-align: justify;
      color: $l_col_keycolor;
      margin: 0 0 8px;
    }
    dd {
      font-size: 14px;
      line-height: 21px;
      text-align: justify;
      margin: 0;
      + dt {
        margin-top: 24px;
      }
    }
  }
  &__btn {
    max-width: 270px;
    margin: auto;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/recommend/lp/blocks/BlockFaq.vue